<template>
  <div class="modal"  v-bind:class="{ 'is-active': displayBill }">
    <div class="modal-background"></div>
    <div class="modal-card box overflow-overlay">
      <p class="sticky"><a class="delete is-medium is-pulled-right mt-5 mr-5" v-on:click="$emit('closebill')"></a></p>
      <div v-html="saleObj" class="model-card-body"></div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'bill',
  props: ['displayBill'],
  computed: {
    ...mapState('cart', ['sale']),
    saleObj () {
      const RL = window.RL

      if (this.sale && RL) {
        try {
          return RL.bill.getDIV(this.sale)
        } catch (error) {
          console.log(error)
        }
      }
      return 'Add Item to view the bill'
    }
  }
}
</script>
